import { DocumentListCard, SkeletonDots } from '@yes.technology/react-toolkit'
import {
  CardContainer,
  ColumnCard,
  ColumnsContainer
} from '../KanbanAutoColumns/KanbanAutoColumns.styles'

interface KanbanSkeletonProps {
  pageColumns: number
}

const KanbanSkeleton = ({ pageColumns = 1 }: KanbanSkeletonProps) => {
  return (
    <ColumnsContainer $columnsPerPage={pageColumns}>
      {[...Array(pageColumns)].map((_, index) => (
        <div key={index}>
          <ColumnCard>
            <SkeletonDots size={4} />
            <CardContainer $isFadingIn={false} $isFadingOut={false}>
              <DocumentListCard
                style={{
                  padding: '16px 8px 8px',
                  border: '1.5px solid #BCBCBE'
                }}
              >
                <SkeletonDots size={4} />
              </DocumentListCard>
            </CardContainer>
          </ColumnCard>
        </div>
      ))}
    </ColumnsContainer>
  )
}

export default KanbanSkeleton
